import React, { Component } from "react";
import * as PropTypes from "prop-types";
import { Col, Checkbox, Form, Input, message, Modal, Row, Select, Switch, Tabs, InputNumber } from "antd";

import { overtimeService } from "../../redux/services";

import {
	HourPickerWithMask,
	UIDrawerForm,
	UIFormSection,
} from "./../../components";

import { opcoes_agrupamento_incidencia, resolverAgrupamento, ORDEM_INCIDENCIAS } from "./../../enum/agrupamentoIncidencia";
import { isAgrupamentoIncidenciaHoraExtraEnabled } from "./../../helpers/auth";

import DayTable from "./Table/create";

const formId = `form-drawer-${Math.floor(Math.random() * 10001)}`;

const TIPO_FAIXAS = [
	{ label: 'Faixas por quantidade', value: 'quantidade', type: ['diario', 'semanal', 'mensal'] },
	{ label: 'Faixas por intervalo', value: 'intervalo', type: ['diario'] },
];

class Create extends Component {
	static propTypes = {
		visible: PropTypes.bool.isRequired,
		onComplete: PropTypes.func.isRequired,
		onClose: PropTypes.func.isRequired,
	};

	constructor(props) {
		super(props);

		this.state = {
			controle_horas: 'diario',
			isLoading: false,
			isSending: false,
			tab: "uteis",
			tabIntern: "diurno",
			interjornada: false,
			agrupar_incidencias: null,
		};
	}

	onTabChange = (key) => {
		this.setState({ tab: key });
	}

	onChangeAgruparIncidencias = (agrupar_incidencias) => {
		const { hidden } = resolverAgrupamento(agrupar_incidencias);

		this.setState(prevState => ({
			agrupar_incidencias,
			tab: hidden.has(prevState.tab) ? ORDEM_INCIDENCIAS.find(dia => !hidden.has(dia)) : prevState.tab,
		}));
	}

	onChangeControleHoras = (controle_horas) => {
		this.setState({ controle_horas });

		// Agrupamento só faz sentido com acumulado entre dias (semanal/mensal) — no diário
		// cada dia é independente, então volta pro comportamento padrão.
		if (controle_horas === 'diario' && this.state.agrupar_incidencias) {
			this.form.setFieldsValue({ agrupar_incidencias: null });
			this.onChangeAgruparIncidencias(null);
		}
	}

	onTabInternChange = (key) => {
		this.setState({ tabIntern: key });
	}

	onOpen = () => {
		setTimeout(() => {
			this.nome && this.nome.focus();
		}, 100);
	};

	onChangeInterjornada = (event) => {
		this.setState({ interjornada: event.target.checked })
	}

	resetFields = () => {
		this.setState({
			tab: "uteis",
			tabIntern: "diurno",
			agrupar_incidencias: null,
		});
	};

	onClose = () => {
		// Reset fields
		this.resetFields();

		// Callback
		this.props.onClose();
	};

	onFinish = async (values) => {
		this.setState({
			isSending: true,
		});

		const { hidden, chavePorIncidencia } = resolverAgrupamento(values.agrupar_incidencias);
		const diasParaValidar = ORDEM_INCIDENCIAS.filter(dia => !hidden.has(dia));

		for (const dia of diasParaValidar) {
			const error = this[dia].validatePercent();
			if (error !== null) {
				message.error("Preencha todos os campos de percentual!");
				this.setState({
					isSending: false,
				});
				this.onTabChange(error.incidencia);
				this[dia].focusInput(error.campo, error.tipo);
				return;
			}
		}

		const data = { ...values };

		const periodos = ["diurno", "noturno", "intervalo"];
		const dados = [];

		diasParaValidar.forEach(dia => {
			periodos.forEach(periodo => {
				const item = this[dia].returnData(periodo);
				if(item) {
					item.incidencia = chavePorIncidencia[dia] || item.incidencia;
					dados.push(item);
				}
			});
		});

		overtimeService.create({
			...data,
			dados: dados,
		})
		.then((response) => {
			this.setState({
				isSending: false,
			});

			// Reset fields
			this.resetFields();

			// Success message
			message.success("Hora extra cadastrada com sucesso.");

			// Callback
			this.props.onComplete();
		})
		.catch((data) => {
			this.setState({
				isSending: false,
			});

			Modal.error({
				title: "Ocorreu um erro!",
				content: String(data),
			});
		});
	};

	render() {
		const { visible } = this.props;
		const { isLoading, isSending, tab, controle_horas, interjornada, agrupar_incidencias } = this.state;
		const tipo_faixa_options  = controle_horas ? TIPO_FAIXAS.filter(item => item.type.includes(controle_horas)) : TIPO_FAIXAS;
		const { hidden, labelPorIncidencia } = resolverAgrupamento(agrupar_incidencias);

		return (
			<UIDrawerForm
				visible={visible}
				width={800}
				onClose={this.onClose}
				isLoading={isLoading}
				isSending={isSending}
				formId={formId}
				icon={<i className="fal fa-business-time" />}
				title="Incluir nova hora extra"
				subtitle="Configure as regras e faixas do novo padrão de horas extras.">
				<Form
					ref={el => this.form = el}
					id={formId}
					layout="vertical"
					scrollToFirstError
					onFinish={this.onFinish}
					initialValues={{
						controle_horas: "diario",
						controle_horas_inicio: null,
						is_active: true,
						agrupar_mesma_porcentagem: 1,
						agrupar_incidencias: null,
						marcar_feriado_como_hora_extra: 1,
						separar_extras_noturnas_de_extras_normais: 0,
						separar_extras_intervalos_de_extras_normais: 0,
						calcular_faltas_somente_para_dia_inteiro_horas_e_dias: 0,
						marcar_falta_dias_em_branco: 0,
						periodo_noturno_hora_inicio: "22:00",
						periodo_noturno_hora_fim: "05:00",
						periodo_noturno_reduzido: "00:52:30",
						periodo_noturno_ate_ultima_batida: 0,
						dividir_jornada_feriado_antes_ou_apos_meia_noite: 0,
					}}>
					<UIFormSection icon={<i className="fal fa-clipboard-list" />} title="Informações gerais">
							<Row gutter={16}>
								<Col xs={24}>
									<Form.Item name="nome" label="Nome" hasFeedback rules={[{ required: true, message: "Campo obrigatório." }]}>
										<Input ref={el => this.nome = el} />
									</Form.Item>
								</Col>
							</Row>

							<Row gutter={16}>
								<Col sm={24} md={12}>
									<Form.Item name="controle_horas" label="Controle de horas" rules={[{ required: true, message: "Campo obrigatório." }]}>
										<Select onChange={this.onChangeControleHoras}>
											<Select.Option value="diario">Diário</Select.Option>
											<Select.Option value="semanal">Semanal</Select.Option>
											<Select.Option value="mensal">Mensal</Select.Option>
										</Select>
									</Form.Item>
								</Col>
								{controle_horas !== 'diario' &&  (
									<Col sm={24} md={8}>
										<Form.Item 
											name="controle_horas_inicio" 
											label="Início do controle de horas" 
											rules={[{ required: true, message: "Campo obrigatório." }]}
										>
											{controle_horas === 'mensal' && (
												<InputNumber 
													ref={el => this.controle_horas_inicio = el} 
													onChange={controle_horas_inicio => this.form.setFieldsValue({ controle_horas_inicio })}
													min={1} 
													max={25} 
												/>
											)}
											{controle_horas === 'semanal' && (
												<Select 
													ref={el => this.controle_horas_inicio = el} 
													onChange={controle_horas_inicio => this.form.setFieldsValue({ controle_horas_inicio })}
												>
													<Select.Option value={0}>Domingo</Select.Option>
													<Select.Option value={1}>Segunda</Select.Option>
													<Select.Option value={2}>Terça</Select.Option>
													<Select.Option value={3}>Quarta</Select.Option>
													<Select.Option value={4}>Quinta</Select.Option>
													<Select.Option value={5}>Sexta</Select.Option>
													<Select.Option value={6}>Sabádo</Select.Option>
												</Select>
											)}
										</Form.Item>
									</Col>
								)}
								<Col sm={24} md={4}>
									<Form.Item name="is_active" label="Ativo" valuePropName="checked" rules={[{ required: true, message: "Campo obrigatório." }]}>
										<Switch />
									</Form.Item>
								</Col>
							</Row>

							<Row gutter={16}>
								<Col xs={24} md={12}>
									<Form.Item name="agrupar_mesma_porcentagem" valuePropName="checked">
										<Checkbox>Agrupar extras de mesma porcentagem</Checkbox>
									</Form.Item>
								</Col>
								<Col xs={24} md={12}>
									<Form.Item name="marcar_feriado_como_hora_extra" valuePropName="checked">
										<Checkbox>Marcar feriados como hora extra</Checkbox>
									</Form.Item>
								</Col>
								<Col xs={24} md={12}>
									<Form.Item name="separar_extras_noturnas_de_extras_normais" valuePropName="checked">
										<Checkbox>Separar extras noturnas de extras normais</Checkbox>
									</Form.Item>
								</Col>
								<Col xs={24} md={12}>
									<Form.Item name="separar_extras_intervalos_de_extras_normais" valuePropName="checked">
										<Checkbox>Separar extras intervalos de extras normais</Checkbox>
									</Form.Item>
								</Col>
								<Col xs={24} md={12}>
									<Form.Item name="calcular_faltas_somente_para_dia_inteiro_horas_e_dias" valuePropName="checked">
										<Checkbox>Calcular faltas somente para o dia inteiro horas e dias</Checkbox>
									</Form.Item>
								</Col>
								<Col xs={24} md={12}>
									<Form.Item name="marcar_falta_dias_em_branco" valuePropName="checked">
										<Checkbox>Marcar como falta dias em branco</Checkbox>
									</Form.Item>
								</Col>
								{controle_horas !== 'diario' && isAgrupamentoIncidenciaHoraExtraEnabled() && (
									<Col xs={24} md={12}>
										<Form.Item name="agrupar_incidencias" label="Agrupar incidências">
											<Select allowClear placeholder="Independente" onChange={this.onChangeAgruparIncidencias}>
												{opcoes_agrupamento_incidencia.map(item => (
													<Select.Option key={item.value ?? "independente"} value={item.value}>{item.label}</Select.Option>
												))}
											</Select>
										</Form.Item>
									</Col>
								)}
								<Col xs={24} md={12}>
									<Row>
										<Col md={8}>										
											<Form.Item name="interjornada" valuePropName="checked">
												<Checkbox onChange={this.onChangeInterjornada}>Interjornada</Checkbox>
											</Form.Item>
										</Col>
										<Col md={10} style={{ marginTop: 10 }}>
											<HourPickerWithMask  name="interjornada_valor" label="Menor que:" disabled={!interjornada} required={interjornada} />
										</Col>
									</Row>
								</Col>
							</Row>

							<Row gutter={16}>
								<Col xs={24}>
									<Tabs activeKey={tab} onChange={this.onTabChange}>
										{!hidden.has('uteis') && (
											<Tabs.TabPane forceRender tab={labelPorIncidencia.uteis || "Úteis"} key="uteis">
												<DayTable
													ref={el => this.uteis = el}
													incidencia="uteis"
													tipo_faixa={tipo_faixa_options}
													onTabChange={this.onTabInternChange}
													tab={this.state.tabIntern}
												/>
											</Tabs.TabPane>
										)}
										{!hidden.has('sabado') && (
											<Tabs.TabPane forceRender tab={labelPorIncidencia.sabado || "Sábado"} key="sabado">
												<DayTable
													ref={el => this.sabado = el}
													incidencia="sabado"
													tipo_faixa={tipo_faixa_options}
													onTabChange={this.onTabInternChange}
													tab={this.state.tabIntern}
												/>
											</Tabs.TabPane>
										)}
										{!hidden.has('domingo') && (
											<Tabs.TabPane forceRender tab={labelPorIncidencia.domingo || "Domingo"} key="domingo">
												<DayTable
													ref={el => this.domingo = el}
													incidencia="domingo"
													tipo_faixa={tipo_faixa_options}
													onTabChange={this.onTabInternChange}
													tab={this.state.tabIntern}
												/>
											</Tabs.TabPane>
										)}
										{!hidden.has('feriado') && (
											<Tabs.TabPane forceRender tab={labelPorIncidencia.feriado || "Feriado"} key="feriado">
												<DayTable
													ref={el => this.feriado = el}
													incidencia="feriado"
													tipo_faixa={tipo_faixa_options}
													onTabChange={this.onTabInternChange}
													tab={this.state.tabIntern}
												/>
											</Tabs.TabPane>
										)}
										{!hidden.has('folga') && (
											<Tabs.TabPane forceRender tab={labelPorIncidencia.folga || "Folga"} key="folga">
												<DayTable
													ref={el => this.folga = el}
													incidencia="folga"
													tipo_faixa={tipo_faixa_options}
													onTabChange={this.onTabInternChange}
													tab={this.state.tabIntern}
												/>
											</Tabs.TabPane>
										)}
										{!hidden.has('dia_especial') && (
											<Tabs.TabPane forceRender tab={labelPorIncidencia.dia_especial || "Dia especial"} key="dia_especial">
												<DayTable
													ref={el => this.dia_especial = el}
													incidencia="dia_especial"
													tipo_faixa={tipo_faixa_options}
													onTabChange={this.onTabInternChange}
													tab={this.state.tabIntern}
												/>
											</Tabs.TabPane>
										)}
										<Tabs.TabPane forceRender tab="Periodo noturno" key="periodo_noturno">
											<Row gutter={16}>
												<Col xs={24} md={8}>
													<HourPickerWithMask name="periodo_noturno_hora_inicio" label="Hora início" required={true} allowMoreThan24={false}/>
												</Col>
												<Col xs={24} md={8}>
													<HourPickerWithMask name="periodo_noturno_hora_fim" label="Hora fim" required={true} allowMoreThan24={false}/>
												</Col>
												<Col xs={24} md={8}>
													<HourPickerWithMask name="periodo_noturno_reduzido" label="Adicional noturno reduzido" seconds={true} required={true} />
												</Col>
											</Row>
											<Row gutter={16}>
												<Col xs={24}>
													<Form.Item name="periodo_noturno_ate_ultima_batida" valuePropName="checked">
														<Checkbox>Período noturno até a ultima batida</Checkbox>
													</Form.Item>
												</Col>
												<Col xs={24}>
													<Form.Item name="dividir_jornada_feriado_antes_ou_apos_meia_noite" valuePropName="checked">
														<Checkbox>Dividir jornadas quando houver feriado antes ou após a meia noite</Checkbox>
													</Form.Item>
												</Col>
											</Row>
										</Tabs.TabPane>
									</Tabs>
								</Col>
							</Row>
					</UIFormSection>
				</Form>
			</UIDrawerForm>
		)
	}
}

export default Create;
